import {createSlice} from "@reduxjs/toolkit";
import _ from "lodash";
import moment from "moment";
import API from "../../app/api";

export const announcementSlice = createSlice({
    name: "announcement",
    initialState: {
        announcements: [],
        loading: undefined,
    },
    reducers: {
        setAnnouncements: (state, patient) => {
            state.announcements = patient.payload;
        },
        setLoading: (state, patient) => {
            state.loading = patient.payload;
        },
    },
});

export const {
    setAnnouncements,
    setLoading
} = announcementSlice.actions;

export const announcements = state => state.announcement.announcements;
export const loading = state => state.announcement.loading;

export const loadAnnouncements = () => (dispatch, getState) => {
    if (!getState().additionalData.loading) {
        dispatch(setLoading(true));
        API.getAnnouncement().then(data => {
            let arr = [];

            // Filter only announcements for Agyle
            _.forEach(data, element => {
                    arr.push({
                        ...element,
                        counter: !!element.countdownTo
                    });
            });

            dispatch(setAnnouncements(arr));
            dispatch(setLoading(undefined));
        }).catch(function (error) {
            console.error(error);
        });
    }
};

export const updateAnnouncement = (announcement) => (dispatch, getState) => {
    let data = {
        "id": announcement.id ? announcement.id : null,
        "enabled": announcement.enabled,
        "text": announcement.text,
        "colour": announcement.colour,
        "countdownTo": announcement.counter
            ? (announcement.countdownTo ? moment(announcement.countdownTo).set({second: 0}).toISOString() : null)
            : null,
        "system": announcement.system? announcement.system: "AGYLE"
    };

    dispatch(setLoading(true));

    API.setAnnouncement(data).then(response => {
        if (response.data && response.status == "200") {
            dispatch(loadAnnouncements());
        }
        dispatch(setLoading(undefined));
    });
};

export const deleteAnnouncement = (announcementId) => (dispatch, getState) => {
    dispatch(setLoading(true));

    API.deleteAnnouncement(announcementId).then(response => {
        if (response.data && response.status == "200") {
            dispatch(loadAnnouncements());
        }
        dispatch(setLoading(undefined));
    });
};

export default announcementSlice.reducer;
